module.exports = {
    JWT: {
        //SECRETKEY: 'TTMPRWW7C35B80F1B82D3A6748B7496D22E15610C8FE2DE07E244E09F73756C8D59451A'
        SECRETKEY: 'TTMPRWW7C35B80F1B'
    },
    URL: {
        SIGNIN: 'https://authprww.thaiticketmajor.com/login?client_id=65fru433ttatodtgpfcr2pjb85&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://prwwid.thaiticketmajor.com',
        SIGNOUT: 'https://authprww.thaiticketmajor.com/logout?client_id=65fru433ttatodtgpfcr2pjb85&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://prwwid.thaiticketmajor.com'
    },
    COOKIE: {
        DOMAIN: '.thaiticketmajor.com'
    }
}